<div class="PGMultistate" (click)="setNext();">
    <div [hidden]="!hasDisplay">
        <ng-content></ng-content>
    </div>
    @if (!hasDisplay) {
        <span>{{value == null ? 'null' : value}}</span>
    }
</div>
